import React from 'react'
import styled from 'styled-components'
import { SizeCompare_DE, SizeCompare_FR } from '../Localization/SizeCompare'


export const SizeCompare = ({
  lang = 'de',
  colorMode = 'light',
}: {
  lang?: 'de' | 'fr'
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const Locales = lang === 'fr' ? SizeCompare_FR : SizeCompare_DE
  return (
    <>
      <div className='title'>{Locales[0][0]}</div>
      <StyledSizeCompare>
        <img src={require('./thwaites_size-compare.png')} />
        <InfoWrapper>
          <InfoCell colorMode={colorMode}>
            <Country>{Locales[1][0]}</Country>
            <Area>{Locales[1][1]}</Area>
          </InfoCell>
          <InfoCell colorMode={colorMode}>
            <Country>{Locales[2][0]}</Country>
            <Area>{Locales[2][1]}</Area>
          </InfoCell>
          <InfoCell colorMode={colorMode}>
            <Country>{Locales[3][0]}</Country>
            <Area>{Locales[3][1]}</Area>
          </InfoCell>
        </InfoWrapper>
      </StyledSizeCompare>
    </>
  )
}

const StyledSizeCompare = styled.div`
  width: 100%;
  text-align: center;
  position: relative;
  img {
    width: 100%;
  }
`
const InfoWrapper = styled.div`
  width: 100%;
  margin-top: -150px;
  display: flex;
`
const InfoCell = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  flex: 0 0 33.33%;
  padding-top: 150px;
  border-right: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--gray-2)'
      : '1px solid var(--gray-4)'};

  &:last-of-type {
    border-right: 0;
  }
`
const Country = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2em;
  min-height: 2.4em;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  justify-content: center;
`
const Area = styled.div`
  font-size: 15px;
`
